import { getCleanedUrlParams, request } from '@utils';
import { ENTITY_TYPES_COMMENTS, LIMIT } from '@constants';
import { BOOKING_HISTORY_CHANGES_DEFAULT_PAGE_SIZE } from 'hooks/bookings/constants';

const getBookingById = async (bookingId) => {
  const results = await request.get(`/v1/bookings/${bookingId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingByOffer = async (bookingId) => {
  const params = {
    responseType: 'arraybuffer',
  };
  const results = await request.get(`/v1/bookings/${bookingId}/offer`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }
  const blob = new Blob([results], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${bookingId}.pdf`;
  link.click();
  return results;
};

const getBookings = async ({ params, payload }) => {
  if (!params?.pageSize) {
    params.pageSize = LIMIT;
  }
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/bookings/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingsEnums = async () => {
  const results = await request.get(`/v1/bookings/enums`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addBooking = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/bookings`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getWWWVehicles = async () => {
  const results = await request.get(`/v1/www/vehicles`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getDownpayment = async (skuId, pricingId, downPayment) => {
  const results = await request.get(
    `/v1/instafleet/catalog/vehicles/downpayment?skuId=${skuId}&pricingId=${pricingId}&downpayment=${downPayment}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingProducts = async (skuId, contractType, contractPeriod) => {
  const results = await request.get(
    `/v1/bookings/products?catalogId=${skuId}&contractType=${contractType}&contractPeriod=${contractPeriod}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const sendOffer = async (bookingId) => {
  const results = await request.post(`/v1/bookings/${bookingId}/send-offer`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};
const updateBooking = async (id, params) => {
  const body = {
    body: params,
  };
  const results = await request.patch(`/v1/bookings/${id}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateBookingWonTime = async (id, params) => {
  const body = {
    body: params,
  };
  const results = await request.patch(`/v1/bookings/${id}/won-time`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteDocument = async (bookingId, docId) => {
  const results = await request.remove(
    `/v1/bookings/${bookingId}/documents/${docId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateDocument = async (bookingId, docId, payload) => {
  const params = {
    body: payload,
  };

  const results = await request.patch(
    `/v1/bookings/${bookingId}/documents/${docId}`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addDocument = async (bookingId, documents) => {
  const fd = new FormData();
  fd.append('documents', documents);
  fd.append('type', '27'); // Other

  const body = {
    body: fd,
    header: {
      Accept: '*/*',
    },
  };
  const results = await request.post(
    `/v1/bookings/${bookingId}/documents`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addLinkedOffer = async (bookingId, linkedId) => {
  const results = await request.post(
    `/v1/bookings/${bookingId}/linkedoffer/${linkedId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteLinkedOffer = async (bookingId, linkedId) => {
  const results = await request.remove(
    `/v1/bookings/${bookingId}/linkedoffer/${linkedId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addGuarantorAgreement = async (bookingId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(
    `/v1/bookings/${bookingId}/guarantor`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateGuarantorAgreement = async (bookingId, agreementId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/bookings/${bookingId}/guarantor/${agreementId}`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteGuarantorAgreement = async (bookingId, agreementId) => {
  const results = await request.remove(
    `/v1/bookings/${bookingId}/guarantor/${agreementId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const sendBookingSms = async (id, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/bookings/${id}/sms`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createPrelead = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/bookings/prelead`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingChangelog = async (bookingId) => {
  const results = await request.get(
    `/v1/changelogs?entityType=booking&entityID=${bookingId}&orderBy=createdAt&order=desc`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingComments = async (bookingId) => {
  const results = await request.get(
    `/v1/comments?entityType=${ENTITY_TYPES_COMMENTS.bookings}&entityID=${bookingId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addBookingComment = async (payload) => {
  const params = {
    body: payload,
  };

  const results = await request.post(`/v1/comments`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteBookingComment = async (commentId) => {
  const results = await request.remove(`/v1/comments/${commentId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingSMS = async ({ params, payload }) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/communications/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingHistoryChanges = async ({
  bookingId,
  page = 1,
  pageSize = BOOKING_HISTORY_CHANGES_DEFAULT_PAGE_SIZE,
  order = 'desc',
  orderBy = 'createdAt',
}) => {
  const params = {
    page,
    pageSize,
    order,
    orderBy,
  };

  const cleanParams = getCleanedUrlParams(params);

  const results = await request.get(
    `/v1/bookings/${bookingId}/history?${new URLSearchParams(cleanParams)}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingEmails = async ({
  bookingId,
  params: {
    page = 1,
    pageSize = BOOKING_HISTORY_CHANGES_DEFAULT_PAGE_SIZE,
    order = 'desc',
    orderBy = 'createdAt',
  },
  payload = {},
}) => {
  const params = {
    page,
    pageSize,
    order,
    orderBy,
  };

  const body = {
    body: payload,
  };
  const cleanParams = getCleanedUrlParams(params);

  const results = await request.post(
    `/v1/emails/history?entityType=booking&entityID=${bookingId}&${new URLSearchParams(
      cleanParams
    )}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingLabels = async ({ params, payload }) => {
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/labels/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createBookingLabel = async (label) => {
  const payload = {
    body: { name: label },
  };

  const results = await request.post('/v1/labels', payload);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const patchBookingLabel = async (labelId, params) => {
  const payload = { body: params };

  const results = await request.patch(`/v1/labels/${labelId}`, payload);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingLinkedTasks = async ({ params, payload }) => {
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/boards/tasks/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingsFilters = async ({ params = {}, payload = {} } = {}) => {
  if (!params?.pageSize) {
    params.pageSize = LIMIT;
  }
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/bookings/filter/autocomplete?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getBookings,
  addBooking,
  getWWWVehicles,
  getBookingById,
  getBookingByOffer,
  getBookingsEnums,
  getDownpayment,
  getBookingProducts,
  sendOffer,
  updateBooking,
  updateBookingWonTime,
  deleteDocument,
  updateDocument,
  addDocument,
  addLinkedOffer,
  deleteLinkedOffer,
  addGuarantorAgreement,
  updateGuarantorAgreement,
  deleteGuarantorAgreement,
  sendBookingSms,
  createPrelead,
  getBookingChangelog,
  getBookingComments,
  addBookingComment,
  deleteBookingComment,
  getBookingSMS,
  getBookingHistoryChanges,
  getBookingEmails,
  getBookingLabels,
  createBookingLabel,
  patchBookingLabel,
  getBookingLinkedTasks,
  getBookingsFilters,
};
